(function () {
  var STORAGE_DISMISSED_UNTIL = 'nds:newsletter-popup:dismissed-until';
  var STORAGE_SUBSCRIBED = 'nds:newsletter-popup:subscribed';

  function getStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function setStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      // localStorage unavailable (private mode, blocked, etc.) -- fail silently
    }
  }

  function init() {
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;

    var card = popup.querySelector('.newsletter-popup__card');
    var closeTriggers = popup.querySelectorAll('[data-newsletter-popup-close]');
    var forcedVisible = popup.hasAttribute('data-force-visible');

    function show() {
      popup.classList.add('newsletter-popup--visible');
      if (card) {
        window.setTimeout(function () {
          var focusTarget = card.querySelector('input, button');
          if (focusTarget) focusTarget.focus();
        }, 350);
      }
    }

    function hide() {
      popup.classList.remove('newsletter-popup--visible');
    }

    function dismiss() {
      var frequencyDays = parseFloat(popup.getAttribute('data-frequency-days')) || 30;
      var dismissedUntil = Date.now() + frequencyDays * 24 * 60 * 60 * 1000;
      setStorage(STORAGE_DISMISSED_UNTIL, String(dismissedUntil));
      hide();
    }

    for (var i = 0; i < closeTriggers.length; i++) {
      closeTriggers[i].addEventListener('click', dismiss);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('newsletter-popup--visible')) {
        dismiss();
      }
    });

    if (forcedVisible) {
      // Landed here right after a successful signup submission -- always show
      // the thank-you state and remember it so the popup never nags again.
      setStorage(STORAGE_SUBSCRIBED, '1');
      show();
      return;
    }

    if (getStorage(STORAGE_SUBSCRIBED) === '1') return;

    var dismissedUntil = parseInt(getStorage(STORAGE_DISMISSED_UNTIL), 10);
    if (dismissedUntil && Date.now() < dismissedUntil) return;

    var delaySeconds = parseFloat(popup.getAttribute('data-delay-seconds')) || 3;
    // Count the delay from navigation start, not from whenever this
    // (deferred) script happens to run -- otherwise slow-loading scripts
    // ahead of this one in the page can silently push the popup out well
    // past the configured delay.
    var elapsedMs = (window.performance && typeof window.performance.now === 'function')
      ? window.performance.now()
      : 0;
    var remainingMs = Math.max(0, delaySeconds * 1000 - elapsedMs);
    window.setTimeout(show, remainingMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
